<div class="md-editor-resize-sensor" #resizeSensor></div>
